export default "__VITE_ASSET__BwLF4Guu__"